/*eslint-disable*/
import React, { useState, useEffect, Fragment } from "react";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import FunderEditPopUp from "../components/Modals/FunderEditModal.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function AdminFunder() {
    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);
    const [funderData, setFunderData] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchFunders();
    }, []);

    const fetchFunders = () => {
        client.getFunderList().then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <button
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    onClick={() => {
                                        setOpenEdit(true);
                                        setFunderData(record);
                                    }}
                                >
                                    &nbsp;
                                    <i className="fa fa-pencil" aria-hidden="true"></i>
                                    &nbsp; Edit &nbsp;
                                </button>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "funder_name",
                    sortable: true,
                    selector: (row) => row.funder_name,
                },
                {
                    name: "display_name",
                    selector: (row) => row.display_name,
                },
                {
                    name: "masked_name",
                    selector: (row) => row.masked_name,
                },
                {
                    name: "funder_partner",
                    sortable: true,
                    selector: (row) => row.funder_partner,
                },
                {
                    name: "masked_funder_name",
                    selector: (row) => row.masked_funder_name,
                },
                {
                    name: "masked_funder",
                    selector: (row) => row.masked_funder,
                },
                {
                    name: "masked_partner",
                    selector: (row) => row.masked_partner,
                },
                {
                    name: "country",
                    selector: (row) => row.country,
                },
                {
                    name: "country_code",
                    selector: (row) => row.country_code,
                },
                {
                    name: "currency",
                    selector: (row) => row.fileFormat,
                },
                {
                    name: "currency_code",
                    selector: (row) => row.currency_code,
                },
                {
                    name: "yield_target",
                    selector: (row) => row.yield_target,
                },
                {
                    name: "cor_target",
                    selector: (row) => row.cor_target,
                },
                {
                    name: "currency_code",
                    selector: (row) => row.currency_code,
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
            ];

            setColumnData(columns);            

            setError(null);
        });
    };

    const closeModal = () => {
        setOpenEdit(false);
    };

    const handleSave = (updatedData) => {
        try {
            client.updateFunder(updatedData)
                .then(() => {
                    fetchFunders();
                    closeModal();
                })
                .catch((err) => {
                    // setEditErrorMessage(err);
                    closeModal();
                });
        }
        catch (error) {
            console.log('Failed to submit map:', error);
        }
  };

    const ExpandedComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;
    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Funder Admin";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error} />}

                    {data && (

                        <>


                            <h2 className="text-36 text-yellow mb-6">Funder Details and Mandates</h2>

                            <TableChart
                                columns={columnData}
                                data={data}
                                expandableRows
                                expandableRowsComponent={ExpandedComponent}
                                defaultSortFieldId={8}
                                dense
                            />

                        </>




                    )}

                </div>
                <FunderEditPopUp objectData={funderData} isOpen={openEdit} onClose={closeModal} onSave={handleSave} />


            </section>

        </>
    );
}

